import Abstract from "../../abstract-view/abstract.js";

export default class RadioLabel extends Abstract {
  constructor(element) {
    super();
    this._element = element;

    this._inputElement = null;

    this._inputHandler = this._inputHandler.bind(this);
  }

  getInputElement() {
    if (!this._inputElement) {
      this._inputElement = this._element.querySelector(`input`);
    }

    return this._inputElement;
  }

  checkIfChecked() {
    return this.getInputElement().checked;
  }

  setCheckedStyles() {
    const checked = this.checkIfChecked();

    if (checked) {
      this._element.classList.add(`form-label_radio_checked`);
    } else {
      this._element.classList.remove(`form-label_radio_checked`);
    }
  }

  setInputHandler(callback) {
    this._callback.input = callback;
    this.getInputElement().addEventListener(`input`, this._inputHandler);
  }

  _inputHandler(evt) {
    this._callback.input(evt);
  }
}
